import { ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  Box,
  Grid,
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
} from "@mui/material";
import SalesItem from "pages/reports/SalesItem";
import React from "react";
import RefundDialog from "./operations/RefundDialog";

const SalesReportList = ({ loading, orders }) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const [openRows, setOpenRows] = React.useState(false);
  const [openRefund, setOpenRefund] = React.useState(false);
  const [order, setOrder] = React.useState(null);

  const startRefund = (order) => {
    setOrder(order);
    setOpenRefund(true);
  };
  return (
    <Grid container>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Box
          sx={{
            backgroundColor: "#e7ebf0",
            borderRadius: 2,
            flex: 1,
          }}
          padding={1}
        >
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Order No </TableCell>
                  <TableCell align="center">Machine name </TableCell>
                  <TableCell align="center">Customer </TableCell>
                  <TableCell align="center" sx={{ minWidth: 120 }}>
                    Date
                  </TableCell>
                  <TableCell align="center">
                    {isSmallScreen ? "Total" : "Grant total"}
                  </TableCell>
                  <TableCell align="center" sx={{ minWidth: 60 }}>
                    Discount
                  </TableCell>
                  <TableCell align="center">Qty</TableCell>
                  <TableCell align="center">Payment method</TableCell>
                  <TableCell align="center">
                    {openRows ? (
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="center"
                        spacing={1}
                        sx={{
                          cursor: "pointer",
                          color: "green",
                          width: "120px",
                        }}
                      >
                        <span onClick={() => setOpenRows(false)}>
                          Close all
                        </span>
                        <ExpandLess />
                      </Stack>
                    ) : (
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={1}
                        sx={{
                          cursor: "pointer",
                          color: "green",
                          width: "120px",
                        }}
                      >
                        <span onClick={() => setOpenRows(true)}>
                          Expand all
                        </span>
                        <ExpandMore />
                      </Stack>
                    )}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <>
                    {Array(10)
                      .fill("")
                      .map((item, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          {Array(10)
                            .fill("")
                            .map((i, j) => (
                              <TableCell
                                align="center"
                                component="th"
                                scope="row"
                                key={j}
                              >
                                <Skeleton animation="wave" />
                              </TableCell>
                            ))}
                        </TableRow>
                      ))}
                  </>
                ) : (
                  <>
                    {orders.map((item) => (
                      <SalesItem
                        order={item}
                        key={item.id}
                        openRows={openRows}
                        setOpenRefund={startRefund}
                      />
                    ))}
                  </>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Grid>
      {openRefund && (
        <RefundDialog
          order={order}
          open={openRefund}
          handleClose={() => setOpenRefund(false)}
        />
      )}
    </Grid>
  );
};

export default SalesReportList;
